import _ from 'lodash'
import isNumericDataType from 'scoreboard/components/is-numeric-data-type'
import isGeographicOrRollup from '../is-geographic-or-rollup'
import DataType from 'scoreboard/datasets/model/data-type'
const { YES_NO, CLUSTER } = DataType
import beginsEndsWithOperators from 'scoreboard/datasets/filters/begins-ends-with-operators'

// operators for rollup filters which are based on searching text
let textualRollupOperators = [ 'contains-any', 'contains-all',
	'does-not-contain-any', 'does-not-contain-all' ].concat(beginsEndsWithOperators)

/**
 * For a given field, determines the default value in the "Choose Rows" dialog.
 * @param field the field
 * @param filters the filters that apply to the field
 * @param dataset the dataset containing the field
 */
function getChooseSummaryTypeDefault(field, filters, dataset) {
	field = field && field.id ? dataset.getUnderlyingField(field.id) : {}

	if (!_.isEmpty(field.ranges)) {
		return 'range'
	} else if (isNumericDataType(field.dataType)) {
		return 'sum'
	}

	if (field.dataType === YES_NO) {
		return 'standard'
	}

	if (isGeographicOrRollup(field.dataType)) {
		// if there's a text filter, default to a list since a tree would be
		// confusing because it wouldn't show all results as expected
		let textFilter = _.find(filters,
			f => _.indexOf(textualRollupOperators, f.operator) != -1)
		return textFilter ? 'list' : 'tree'
	}

	if (field.dataType === CLUSTER) {
		return 'value'
	}

	if (!_.isEmpty(field.ranges)) {
		return 'range'
	}

	return 'standard'
}

export default getChooseSummaryTypeDefault

getChooseSummaryTypeDefault.__filename__ = 'datasets/overview/get-choose-summary-type-default.js'
